import { render, staticRenderFns } from "./BoardItem.vue?vue&type=template&id=8c357d10"
import script from "./BoardItem.vue?vue&type=script&lang=js"
export * from "./BoardItem.vue?vue&type=script&lang=js"
import style0 from "./BoardItem.vue?vue&type=style&index=0&id=8c357d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports